import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <FeaturesSection />
        <FAQSection />
        <TopicsSection />
        <IndexSection />
        <AboutSection />
        <ContactSection />
        <UpdatesSection />
        <RankingSection />
        <MediaSection />
        <CarouselSection />
        <AppSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}